module.exports = __webpack_public_path__ + "img/plan01_girl02.fdfdc3f8.png";